import { AppHeader, LoadingPage, ReemaThemeV2 } from '@act/storybook';
import { ThemeProvider } from '@mui/material/styles';
import { ConsentAppRouter } from '../consents/member-view/ConsentAppRouter';
import { Provider } from 'react-redux';
import { getStore } from 'redux/consentStore';
import { useGetAppConfig } from 'utilities/app-config-hook';
import { LanguageProvider } from 'utilities/language-provider';
import ConsentActionsInitializer from '../consents/member-view/ConsentActionsInitializer';

// Initialize i18n
import '../../utilities/i18n';

import './consents-app.scss';
import { useSearchParams, useParams } from 'react-router-dom';

const ConsentApp = () => {
  const configLoaded = useGetAppConfig();
  const [params] = useSearchParams();
  const { termKey } = useParams<{ termKey?: string }>();
  const key = params.get('key');

  if (!configLoaded) {
    return (
      <ThemeProvider theme={ReemaThemeV2.LIGHT_MODE}>
        <LoadingPage></LoadingPage>
      </ThemeProvider>
    );
  }

  return (
    <div id="consent-app">
      <ThemeProvider theme={ReemaThemeV2.LIGHT_MODE}>
        <Provider store={getStore()}>
          <ConsentActionsInitializer />
          <LanguageProvider>
            <AppHeader
              href={`/?key=${key}`}
              withLogo
              disableAnimations={true}
              disableMobileMenu={true}
            />
            <ConsentAppRouter termKey={termKey} />
          </LanguageProvider>
        </Provider>
      </ThemeProvider>
    </div>
  );
};

export default ConsentApp;
